import { render, staticRenderFns } from "./second-classify.vue?vue&type=template&id=67be1c1c&scoped=true&"
import script from "./second-classify.vue?vue&type=script&lang=js&"
export * from "./second-classify.vue?vue&type=script&lang=js&"
import style0 from "./second-classify.vue?vue&type=style&index=0&id=67be1c1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67be1c1c",
  null
  
)

export default component.exports